import { EnglishDictionary } from './en';

const fr: EnglishDictionary = {
  login: {
    title: 'Bienvenue',
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    submit: 'Se connecter',
    noAccount: "Vous n'avez pas de compte ?",
    signUp: "S'inscrire",
    intro: 'Connexion à votre compte',
    success: 'Connexion réussie',
    error: 'Erreur lors de la connexion',
    missingCredentials: 'Veuillez entrer un email et un mot de passe valides.',
    blocked: 'Votre compte a été temporairement désactivé.',
  },
  changePassword: {
    title: 'Changer le mot de passe',
    intro:
      "Veuillez confirmer l'adresse électronique de votre compte et un code unique vous sera envoyé pour réinitialiser votre mot de passe.",
    email: 'Email',
    login: 'Connexion',
    oneTimeCode: 'Code à usage unique',
    confirmPassword: 'Confirmer le mot de passe',
    newPassword: 'Nouveau mot de passe',
    minPassword: 'Le mot de passe doit contenir au moins 6 caractères',
    enterOTP: 'Veuillez entrer le code OTP envoyé à votre email.',
    verifyOTP: 'Vérifier OTP',
    sentOTP: 'OTP envoyé à votre email',
    errorSendingOTP:
      "Impossible d'envoyer l'email contenant le code à usage unique. Veuillez réessayer ou contacter le support.",
    invalidOTP: 'OTP invalide',
    verifiedOTP: 'OTP vérifié avec succès',
    passwordChanged: 'Mot de passe changé avec succès',
    errorChangingPassword: 'Erreur lors du changement de mot de passe',
    buttonText: 'Changer le mot de passe',
    errorNoUser: "Aucun utilisateur n'est associé à l'adresse e-mail {email}.",
  },
  logout: {
    success: 'Vous avez été déconnecté avec succès.',
    error: 'Une erreur est survenue lors de la déconnexion.',
  },
  resetPassword: {
    title: 'Réinitialiser le mot de passe',
    email: 'Email',
    submit: 'Envoyer le lien',
    backToLogin: 'Retour à la connexion',
    success: 'Email de réinitialisation envoyé',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    changePassword: 'Changer le mot de passe',
  },
  validation: {
    required: 'Ce champ est requis',
    invalidEmail: 'Adresse email invalide',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
  },
  fields: {
    fullName: 'Nom complet',
    email: 'E-mail',
    phone: 'Téléphone',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    doctor: 'Médecin',
    indications: 'Indications',
    notes: 'Notes',
    id: 'ID',
    patientId: 'ID du Patient',
    dateOfBirth: 'Date de Naissance',
    gender: 'Genre',
    created: "Date d'Ajout",
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    createdBy: 'Créé par',
    male: 'Masculin',
    female: 'Féminin',
    other: 'Autre',
    fileSize: 'Taille du fichier',
    revisionHistory: 'Historique des révisions',
    exportStatus: "Statut d'exportation",
  },
  patientsPage: {
    title: 'Patients',
    description: 'Gérez vos patients',
    newPatient: 'Nouveau Patient',
    instructions: `##### **Qui ajoutez-vous?**
Remplissez les champs pour créer un profil de patient.
##### **Conseils:**
- indique un champ obligatoire
- Remplir le champ optionnel peut être utile plus tard
- Toutes les données des patients sont stockées de manière anonyme`,
  },
  addPatientPage: {
    title: 'Ajouter un Patient',
    description: 'Ajouter un nouveau patient au système',
    success: 'Patient ajouté avec succès',
    error: "Erreur lors de l'ajout du patient",
    submitText: 'Ajouter le Patient',
  },
  sections: {
    generalPatientInformation: 'Informations Générales du Patient',
    medicalInformation: 'Informations Médicales',
    orderInformation: 'Informations sur la commande',
  },
  placeholders: {
    fullName: 'Entrez le nom complet',
    email: "Entrez l'adresse e-mail",
    phone: 'Entrez le numéro de téléphone',
    doctor: 'Entrez les informations du médecin',
    indications: 'Entrez les informations sur les indications',
    notes: 'Entrez les notes',
    patientId: "Entrez l'ID du patient",
    dateOfBirth: 'Entrez la date de naissance',
    gender: 'Entrez le genre',
    password: 'Entrez le mot de passe',
    confirmPassword: 'Confirmez votre mot de passe',
    companyName: "Entrez le nom de l'entreprise",
    clientId: "Entrez l'ID client",
    line1: "Entrez la ligne d'adresse 1",
    city: 'Entrez la ville',
    postalCode: 'Entrez le code postal',
    country: 'Entrez le pays',
    state: "Entrez l'état",
  },
  onUpdate: {
    title: 'Mettre à Jour le Patient',
    success: 'Patient mis à jour avec succès',
    error: 'Erreur lors de la mise à jour du patient',
  },
  onUpdateOrder: {
    title: 'Mettre à jour la commande',
    success: 'Commande mise à jour avec succès',
    error: 'Erreur lors de la mise à jour de la commande',
  },
  onDelete: {
    title: 'Supprimer le Patient',
    message:
      'Êtes-vous sûr de vouloir supprimer ce patient ? Tous les scans 3D, E-limbs et produits non terminés liés à ce patient seront supprimés. Les produits commandés seront conservés dans la page de commande, mais ne pourront pas être modifiés.',
    confirmText: 'Supprimer',
    success: 'Patient supprimé avec succès',
    error: 'Erreur lors de la suppression du patient',
    elimb: {
      title: 'Suprimir E-limb',
      message: 'Êtes-vous sûr de vouloir supprimer cette E-limb ?',
      success: 'E-limb supprimé avec succès',
      error: 'Erreur de suppression de E-limb',
    },
    scan: {
      title: "Supprimer l'analyse",
      message: 'Êtes-vous sûr de vouloir supprimer cette analyse ?',
      success: 'Scan supprimé avec succès',
      error: "Erreur de suppression de l'analyse",
    },
  },
  onDeleteUser: {
    title: "Supprimer l'Utilisateur",
    message:
      'Êtes-vous sûr de vouloir supprimer cet utilisateur ? Tous les patients, produits commandés, scans 3D et E-limbs liés à cet utilisateur seront transférés à un autre utilisateur.',
    transferTo: 'Veuillez spécifier à qui les données seront transférées :',
    confirmText: 'Supprimer',
    success: 'Utilisateur supprimé avec succès',
    error: "Erreur lors de la suppression de l'utilisateur",
    selectUserToTransfer: "Sélectionner l'utilisateur auquel les données seront transférées",
    noUserToTransfer: 'Aucun utilisateur à transférer',
    lastAdmin:
      'Il doit toujours y avoir au moins un administrateur. Pour modifier cela, veuillez contacter OTB.',
    forbidden: "Vous n'avez pas l'autorisation de supprimer ce compte.",
    referenced:
      "Ce compte est encore lié à d'autres enregistrements et n'a pas pu être supprimé. Rien n'a été modifié — veuillez contacter OTB.",
    invalidTransfer:
      "Les données ne peuvent être transférées qu'à un autre utilisateur actif de la même entreprise. Rien n'a été modifié — veuillez choisir un autre utilisateur.",
  },
  onCreatePatient: {
    existingPatientName: {
      title: 'Patient existant',
      message:
        "Vous avez créé un patient avec le même nom qu'un patient déjà existant : {fullName}.\nVoulez-vous enregistrer ceci comme un nouveau patient ou modifier le patient existant ?",
      confirmText: 'Enregistrer comme nouveau patient',
      cancelText: 'Modifier le patient existant',
    },
    existingPatientId: {
      title: 'Patient existant',
      message:
        "Vous avez créé un patient avec le même ID qu'un patient déjà existant : {fullName}.\nVoulez-vous modifier le patient existant ou annuler la création du nouveau patient ?",
      confirmText: 'Modifier le patient existant',
      cancelText: 'Annuler la création du patient',
      cancelMessage: 'Création du patient annulée',
    },
  },
  onEditPatient: {
    existingPatientName: {
      title: 'Patient existant',
      message:
        "Vous avez mis à jour un patient portant le même nom qu'un patient déjà existant : {fullName}.\nVoulez-vous appliquer vos modifications au patient actuel?",
      confirmText: 'Appliquer les modifications',
      cancelText: 'Annuler la mise à jour du patient',
    },
  },
  actions: {
    edit: 'Modifier',
    delete: 'Supprimer',
    view: 'Voir le patient',
    add: 'Ajouter un patient',
    save: 'Enregistrer',
    cancel: 'Annuler',
    continue: 'Continuer',
    reorder: 'Commander à nouveau',
    duplicate: 'Dupliquer',
    duplicateConfig: 'Dupliquer et mettre à jour la configuration',
    addToCart: 'Ajouter au panier',
    removeFromCart: 'Retirer du panier',
    upload: 'Télécharger',
    review: 'Évaluer le produit',
  },
  messages: {
    created: 'Patient créé',
    updated: 'Patient mis à jour',
    deleted: 'Patient supprimé',
    createError: 'Erreur lors de la création du patient',
    updateError: 'Erreur lors de la mise à jour du patient',
    deleteError: 'Erreur lors de la suppression du patient',
  },
  confirmations: {
    update: {
      title: 'Mettre à jour',
      message: 'Êtes-vous sûr de vouloir mettre à jour cet élément?',
      confirmText: 'Mettre à jour',
    },
    delete: {
      title: 'Supprimer',
      message: 'Êtes-vous sûr de vouloir supprimer cet élément?',
      confirmText: 'Supprimer',
    },
    create: {
      confirmText: 'Créer',
    },
  },
  overviewPage: {
    title: 'Aperçu du Patient',
    description: 'Voir et gérer les détails du patient',
    newProduct: 'Nouveau Produit',
    noProducts: 'Aucun produit disponible',
    productId: 'ID du Produit',
    productType: 'Type de Produit',
    createdOn: 'Créé le',
    status: 'Statut',
    newScan: 'Nouveau Scan',
    noScans: 'Aucun scan disponible',
    scanId: 'ID du Scan',
    scanName: 'Nom du Scan',
    scannedLimb: 'Membre Scanné',
    newElimb: 'Nouveau E-membre',
    noElimbs: 'Aucun e-membre disponible',
    elimbId: 'ID du E-membre',
    elimbType: 'Type de E-membre',
    editNotes: 'Modifier les Notes',
    notesUpdated: 'Notes mises à jour avec succès',
    notesUpdateError: 'Erreur lors de la mise à jour des notes',
    scans: 'Scans',
    elimbs: 'E-membres',
    products: 'Produits',
  },

  admin: {
    title: "Panneau d'Administration",
  },
  users: {
    title: 'Utilisateurs',
    add: 'Ajouter un Utilisateur',
    edit: 'Modifier un Utilisateur',
    delete: 'Supprimer un Utilisateur',
    sections: {
      generalInfo: 'Informations Générales',
      loginInfo: 'Informations de Connexion',
      roles: 'Rôles',
      passwordPicker: {
        title: 'Qui doit définir le mot de passe ?',
        true: 'Vous',
        false: "L'utilisateur",
      },
      warning: {
        alert: "Cet utilisateur n'a pas encore défini de mot de passe.",
        button: 'Envoyer un nouvel e-mail',
      },
      platformAccess: {
        title: 'Accès à la plateforme',
        field: 'Bloqué',
      },
    },
    roles: {
      professional: 'Professionnel',
      admin: 'Administrateur',
      distributor: 'Distributeur',
      master: 'Maître',
    },
    fields: {
      id: 'ID',
      fullName: 'Nom complet',
      email: 'Email',
      phone: 'Téléphone',
      createdAt: 'Créé le',
      orderedProducts: 'Produits commandés',
      unfinishedProducts: 'Produits non finis',
      roles: 'Rôles',
    },
    instructions: 'Instructions pour gérer les utilisateurs',
  },
  companies: {
    title: 'Entreprises',
    add: 'Ajouter une Entreprise',
    edit: 'Modifier une Entreprise',
    delete: 'Supprimer une Entreprise',
    new: 'Nouvelle Entreprise',
    description: 'Créer une nouvelle entreprise',
    filterByDistributor: 'Filtrer par distributeur',
    addDistributor: 'Ajouter un distributeur',
    sections: {
      generalInfo: "Informations générales de l'entreprise",
      settings: 'Paramètres',
      address: 'Adresse',
      users: 'Utilisateurs',
      companyOverview: "Présentation de l'entreprise",
      productWorkflows: 'Workflows produit',
      supportTickets: 'Tickets de support',
      orderedProducts: 'Produits commandés',
      advancedSettings: 'Paramètres avancés',
      productWorkflowStepConfigurationCard: {
        title: 'Afficher / masquer les étapes du flux de travail des produits {material}',
      },
    },
    fields: {
      name: "Nom de l'entreprise",
      clientId: 'ID client (4 caractères au minimum)',
      clientIdHeader: 'ID client',
      generalEmail: 'Adresse e-mail générale',
      generalPhone: 'Numéro de téléphone général',
      fullName: 'Nom complet',
      deletedUser: 'Utilisateur supprimé',
      email: 'Email',
      phone: 'Téléphone',
      line1: 'Adresse',
      city: 'Ville & code postal',
      state: 'État/Province',
      postalCode: 'Code postal',
      country: 'Pays',
      createdBy: 'Créateur',
      dateCreated: 'Date de création',
      id: 'ID',
      openSupportTickets: 'Tickets de support ouverts',
      users: 'Utilisateurs',
      orderedProducts: 'Produits commandés',
      unfinishedProducts: 'Produits non finis',
    },
    settings: {
      useOwnPatientId: {
        label: 'Utiliser son propre ID patient',
        description:
          'En cochant cette case, vous pourrez définir votre propre ID patient, ce qui en fait un champ obligatoire. En décochant cette case, la plateforme générera les ID patients de manière aléatoire.',
      },
      sharePatients: {
        label: 'Partager les patients entre utilisateurs',
        description:
          "En cochant cette case, tous les utilisateurs de cette organisation peuvent voir, modifier et créer des produits pour tous les patients. En décochant cette case, seul l'utilisateur qui crée un patient peut voir, modifier ou créer un produit pour le patient.",
      },
      useShippingInformation: {
        label: "Utiliser les informations d'expédition pour les entreprises filiales",
        description:
          "En cochant cette case, tous les produits commandés par les entreprises créées par cette organisation seront expédiés et liés à ce distributeur. (Non modifiable par l'administrateur de l'entreprise)",
      },
      adminOrderFollowUp: {
        label: "L'administrateur est inclus dans le suivi des commandes de l'entreprise.",
        description:
          "En cochant cette case, les administrateurs reçoivent un e-mail lorsqu'un produit est commandé.",
      },
      orderReferenceFollowUp: {
        label: 'Rappels de référence de commande.',
        description:
          "En cochant cette case, vous recevrez un rappel quotidien vous invitant à remplir votre référence de commande si celle-ci n'a pas encore été renseignée.",
      },
      credits: {
        title: 'Crédits',
      },
      onlyAdminsCanBuyCredits: {
        label: 'Seuls les administrateurs peuvent acheter des crédits',
        description:
          'En cochant cette case, les professionnels peuvent uniquement demander des crédits et les administrateurs les achètent.',
      },
      pricePerCredit: {
        label: 'Prix par crédit (EUR)',
        description:
          'Ce qu’un crédit coûte à cette organisation en euros. Laissez 0 pour reprendre le prix de son distributeur, ou à défaut celui d’Orthobroker.',
      },
      creditPriceCarpi: {
        label: 'Carpi (crédits)',
        description:
          'Crédits, et non euros, facturés pour un STL Carpi. Zéro reprend la valeur de son distributeur, ou à défaut celle d’Orthobroker.',
      },
      creditPriceMino: {
        label: 'Mino (crédits)',
        description:
          'Crédits, et non euros, facturés pour un STL Mino. Zéro reprend la valeur de son distributeur, ou à défaut celle d’Orthobroker.',
      },
      creditPriceVolar: {
        label: 'Volar (crédits)',
        description:
          'Crédits, et non euros, facturés pour un STL Volar. Zéro reprend la valeur de son distributeur, ou à défaut celle d’Orthobroker.',
      },
      notifications: {
        success: "Paramètres de l'entreprise mis à jour.",
        error: "Une erreur s'est produite lors de la mise à jour des paramètres de l'entreprise.",
      },
    },
    whitelabel: {
      title: 'Marque blanche',
      logo: {
        label: "Logo de l'entreprise",
        description:
          "Remplace le logo OrthoSolid pour les utilisateurs de cette entreprise. PNG, JPG ou WebP, jusqu'à 2 Mo.",
        upload: 'Choisir une image',
        remove: 'Supprimer le logo',
        removeTitle: "Supprimer le logo de l'entreprise",
        removeMessage:
          'Supprimer le logo de cette entreprise ? Ses utilisateurs reverront le logo OrthoSolid.',
        empty: "Aucun logo d'entreprise : les utilisateurs voient le logo OrthoSolid.",
      },
      notifications: {
        success: "Le logo de l'entreprise a été mis à jour.",
        removed: "Le logo de l'entreprise a été supprimé.",
        error: "Une erreur s'est produite lors de la mise à jour du logo de l'entreprise.",
        notAllowed: "Seuls les utilisateurs master peuvent modifier le logo de l'entreprise.",
        noFile: "Choisissez d'abord une image.",
        invalidType: "Ce fichier n'est pas une image prise en charge. Utilisez PNG, JPG ou WebP.",
        tooLarge: 'Cette image est trop volumineuse. La taille maximale est de 2 Mo.',
      },
    },
    actions: {
      create: {
        errorPrefix: "Erreur lors de la création de l'entreprise :",
      },
      delete: {
        button: "Supprimer l'entreprise",
        title: "Supprimer l'entreprise",
        message: 'Êtes-vous sûr de vouloir supprimer cette entreprise ?',
        success: "L'entreprise a été supprimée avec succès",
        error: "Une erreur s'est produite lors de la suppression de l'entreprise",
      },
      edit: {
        success: 'La mise à jour de la société a été effectuée avec succès.',
        errorPrefix: "Erreur lors de la mise à jour de l'entreprise :",
      },
      companyID: "Le numéro d'identification de l'entreprise est obligatoire.",
      error:
        "L'ID client ne peut contenir que des lettres, des chiffres, des points, des tirets et des traits de soulignement.",
      saveDecisionFlowOptions: {
        success: 'Les options que cette entreprise peut choisir dans {flow} ont été enregistrées.',
        notAllowed:
          'Vous ne pouvez définir les options que des entreprises que vous avez enregistrées, dans la limite de vos propres options.',
        error:
          "Les options de {flow} n'ont pas pu être enregistrées. Rechargez la page et réessayez.",
      },
      toggleProductWorkflowStepConfigurations: {
        field: 'Basculer les étapes du flux de travail {material}',
        productionLocation: {
          title: 'Site de production',
        },
        material: {
          title: 'Matériau',
        },
        thumbSupport: {
          title: 'Support pour le pouce',
        },
        braceLength: {
          title: "Longueur de l'attelle",
        },
        openingLocation: {
          title: "Lieu d'ouverture",
        },
        hinges: {
          title: 'Charnières',
        },
        hingedOption: {
          title: 'Option à charnière',
        },
        padding: {
          title: 'Rembourrage',
        },
        extraPadding: {
          title: 'Rembourrage supplémentaire',
        },
        straps: {
          title: 'Sangles',
        },
      },
      duplicateConfig: {
        title: 'Dupliquer un produit avec une nouvelle configuration',
        noOutcome:
          'Aucune configuration ne correspond à ces réponses. Modifiez une réponse, ou demandez à un administrateur de compléter le flux de décision.',
      },
    },
    instructions: `##### **Que faire ?**
Remplissez les champs (obligatoires) pour créer une nouvelle entreprise/distributeur et attribuer un utilisateur à l'entreprise.
##### **Conseils :**
- Les champs obligatoires sont indiqués par un *
- Si vous ne remplissez pas un ID patient, le logiciel en générera automatiquement un. Vous pouvez le modifier plus tard`,
  },
  roles: {
    title: 'Rôles',
    admin: 'Admin',
    distributor: 'Distributeur',
    master: 'Master',
    user: 'Utilisateur',
  },
  status: {
    pending: 'Commande En Attente',
    inProgress: 'Commande En Cours',
    completed: 'Commande Terminée',
    cancelled: 'Commande Annulée',
  },
  orders: {
    title: 'Commandes',
    new: 'Nouvelle Commande',
    details: 'Détails de la Commande',
    status: 'Statut',
    date: 'Date de Commande',
    id: 'ID de Commande',
    placeOrder: 'Passer la Commande',
    sections: {
      generalInfo: 'Informations Générales',
      shippingInfo: "Informations d'Expédition",
    },
    fields: {
      status: 'Statut',
      reference: 'Référence',
      clientId: 'ID client',
      id: 'ID',
      created: 'Créé',
      totalItems: 'Total des articles',
      notes: 'Notes',
      companyName: 'Entreprise',
      material: 'Matériau',
    },
    email: {
      received:
        'Nous sommes heureux de vous annoncer que nous avons reçu votre commande et que nous la traiterons sous peu. Vous trouverez ci-dessous les détails de votre commande :',
      beingPrepared:
        "Votre commande est en cours de préparation et nous vous informerons dès qu'elle sera en route. Vous pouvez suivre la progression en vérifiant le statut de votre commande sur la plateforme. Si vous avez des questions ou si vous avez besoin d'aide, n'hésitez pas à nous contacter à l'adresse orders@orthosolid.com. »",
      signature:
        "Cordialement\nL'équipe d'Orthobroker\nThe Orthobroker Team\nhttps://platform.orthosolid.com",
    },
  },
  shipping: {
    title: 'Informations de Livraison',
    name: 'Nom Complet',
    email: 'Email',
    phone: 'Téléphone',
    address: 'Adresse',
    city: 'Ville',
    postalCode: 'Code Postal',
    country: 'Pays',
  },
  preview: {
    demo: 'Aperçu démo',
    noPreview: 'Aperçu non disponible',
    noGlbFound: 'Aucun GLB trouvé',
    loading: 'Chargement...',
  },
  modelPreview: {
    orientationLabel: 'Orientation',
    autoOrientation: 'Orientation automatique',
    autoOrientationTooltip: 'Orientation automatique basée sur les dimensions du modèle',
    xAxisUp: 'Axe X vers le haut',
    xAxisUpTooltip: "Pivoter pour rendre l'axe X vertical",
    yAxisUp: 'Axe Y vers le haut',
    yAxisUpTooltip: 'Orientation verticale par défaut',
    zAxisUp: 'Axe Z vers le haut',
    zAxisUpTooltip: "Pivoter pour rendre l'axe Z vertical",
    error: "Il n'y a pas encore de modèle à afficher.",
    unavailableCombination: "Cette combinaison n'est pas disponible.",
  },
  support: {
    title: "Demander de l'aide",
    description1:
      "Merci de nous contacter, nous sommes heureux de vous aider à résoudre votre problème. Pour nous assurer de fournir le bon support à tous les utilisateurs, nous souhaitons vous informer qu'il existe un manuel complet de la plateforme que vous pouvez consulter en cas de problème.",
    description2:
      "Si votre problème n'est pas traité dans le manuel, veuillez le décrire dans la zone ci-dessous. Nous l'examinerons dans les 24 heures (pendant les jours ouvrables). Vous recevrez une notification lorsque nous aurons traité votre ticket",
    manualButton: 'Manuel de la plateforme',
    issueLabel: 'Décrivez votre problème',
    issuePlaceholder: 'Veuillez décrire votre problème ici...',
    createButton: 'Créer un ticket',
    typeLabel: 'Concernant',
    typePlaceholder: 'Sélectionner un sujet',
    addTicket: 'Ajouter un ticket',
    platformManual: 'Manuel de la plateforme',
    platformManualDescription: 'Lisez les directives ou recherchez une fonctionnalité',
    academy: 'Académie',
    academyDescription: 'Devenez un expert grâce aux tutoriels vidéo',
    button: 'Marqué comme résolu',
    notification: {
      resolved: {
        success: "Marqué comme résolu l'objet d'une enquête",
        error:
          "Une erreur inattendue s'est produite lors du marquage comme résolu. Veuillez réessayer.",
      },
      under_investigation: {
        success: "Marqué comme faisant l'objet d'une enquête",
        error:
          "Une erreur inattendue s'est produite lors du marquage comme faisant l'objet d'une enquête. Veuillez réessayer.",
      },
    },
  },
  buttons: {
    back: 'Retour',
    cancel: 'Annuler',
    save: 'Enregistrer',
    edit: 'Modifier',
    delete: 'Supprimer',
    add: 'Ajouter',
    select: 'Sélectionner',
    selected: 'Sélectionné',
    discover: 'Découvrir',
    readMore: 'Lire la suite',
    continue: 'Continuer',
    clear: 'Effacer',
  },
  errors: {
    notFound: {
      title: '404',
      subtitle: 'Page non trouvée',
      description: "La page que vous recherchez n'existe pas ou a été déplacée.",
      action: "Retour à la page d'accueil",
    },
    general: {
      title: 'Quelque chose a mal tourné!',
      description: 'Une erreur inattendue est survenue. Veuillez réessayer.',
      action: 'Réessayer',
    },
    noAccess: "Vous n'avez pas accès à cette page.",
    duplicate: {
      error: "Une erreur s'est produite lors de la duplication du produit.",
    },
  },
  createUser: {
    errors: {
      alreadyExists:
        "Cet utilisateur dispose déjà d'un compte actif. Si vous devez réinitialiser le mot de passe, veuillez contacter votre administrateur.",
      passwordLength: 'Le mot de passe doit comporter au moins 6 caractères.',
      error: "Erreur lors de la création de l'authentification :",
      noEmail:
        "Une erreur s'est produite lors de la récupération de votre adresse e-mail. Veuillez contacter le service d'assistance.",
      JWTExpired: {
        new: 'Votre invitation à la plateforme OrthoSolid a expiré. Veuillez contacter votre administrateur pour en obtenir une nouvelle.',
        reset:
          'Votre invitation à réinitialiser votre mot de passe a expiré. Veuillez contacter votre administrateur pour en obtenir une nouvelle.',
      },
    },
    subject: 'Définissez votre mot de passe pour OrthoSolid.',
    mail: `Cher {fullName},
    
    Votre administrateur a créé un compte pour vous sur la plateforme OrthoSolid.
    Rendez-vous sur ce lien pour créer un mot de passe : {passwordURL}

    Cordialement,
    L'équipe OrthoSolid. 
    `,
    html: `
      <p>Cher {fullName},</p>
      <p>
        Votre administrateur a créé un compte pour vous sur la plateforme OrthoSolid.
        Rendez-vous sur <a href="{passwordURL}">ce lien</a> pour créer un mot de passe.
      </p>
      <p>
        Cordialement,<br />
        L'équipe OrthoSolid.
      </p>
    `,
  },
  onResetPassword: {
    message:
      "Lorsque l'utilisateur clique sur « Continuer », un e-mail lui sera envoyé. Il sera alors redirigé vers une page où il pourra réinitialiser son mot de passe.",
    success: "L'e-mail a été envoyé à l'utilisateur.",
    error: "Une erreur s'est produite lors de l'envoi de l'e-mail à l'utilisateur.",
    mail: {
      subject: 'Réinitialisez votre mot de passe pour la plateforme Orthosolid.',
      text: `Cher {fullName},
    
    Votre administrateur a demandé une réinitialisation de votre mot de passe.
    Cliquez sur ce lien pour le réinitialiser : {passwordURL}

    Cordialement,
    L'équipe OrthoSolid. 
    `,
      html: `
      <p>Cher {fullName},</p>
      <p>
        Votre administrateur a demandé une réinitialisation de votre mot de passe.
        Cliquez sur <a href="{passwordURL}">ce lien</a> pour le réinitialiser.
      </p>
      <p>
        Cordialement,<br />
        L'équipe OrthoSolid.
      </p>
    `,
    },
    errorUserWithoutPassword: `<p>Cet utilisateur dispose d'un compte, mais n'a pas de mot de passe. Veuillez vous rendre sur <a href="{passwordURL}">ce lien</a> afin d'en créer un.</p>`,
  },
  common: {
    language: 'Langue',
    loading: 'Chargement...',
    noResults: 'Aucun résultat trouvé',
    search: 'Rechercher',
    noValue: '-',
    loadingPage: 'Chargement de la page...',
    loadingData: 'Chargement des données...',
    processing: 'Traitement...',
    removeFromCart: 'Retirer du panier',
    fields: {
      created: 'Créé',
    },
    cancel: 'Annuler',
    hiddenData: 'Ces données sont masquées',
  },
  onResendNewPasswordMail: {
    title: 'Een e-mail voor een nieuw wachtwoord versturen',
    message:
      "Lorsque l'utilisateur clique sur « Continuer », un e-mail lui sera envoyé. Il sera alors redirigé vers une page où il aura une nouvelle occasion de définir son mot de passe.",
  },
  ticketDetails: {
    generalInfo: 'Informations générales du ticket',
    involving: 'Concernant',
    ticketId: 'ID du ticket',
    scanId: 'ID du scan',
    createdOn: 'Créé le',
    createdBy: 'Créé par',
    lastAdjusted: 'Dernière modification le',
    lastAdjustedBy: 'Modifié par',
    delete: 'Supprimer',
    deleteTitle: 'Supprimer le ticket',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce ticket ?',
    deleteSuccess: 'Ticket supprimé',
    deleteError: 'Erreur lors de la suppression du ticket',
    resolveTicket: 'Résoudre le ticket',
    ticketResolved: 'Ticket résolu',
  },
  productCatalogue: {
    title: 'Catalogue de produits',
    viewAll: 'Voir tout',
  },
  discussion: {
    title: 'Discussion',
    newMessage: 'Nouveau message',
    send: 'Envoyer',
    reply: 'Répondre',
  },
  form: {
    save: 'Enregistrer les modifications',
    delete: 'Supprimer',
    required: 'Requis',
    enterValue: 'Entrer une valeur',
    selectDate: 'Sélectionner une date',
    slider: {
      autoAdjust: 'Activer/désactiver le calcul automatique',
    },
  },
  notes: {
    title: 'Notes',
    edit: 'Modifier les notes',
    placeholder: 'Entrer des notes',
    updated: 'Notes mises à jour',
    updateError: 'Erreur lors de la mise à jour des notes',
  },
  referenceNumber: {
    title: 'Numéro de référence',
    placeholder: 'Numéro de référence de votre commande (le cas échéant)',
  },
  notifications: {
    success: 'Succès',
    error: 'Erreur',
    info: 'Information',
    warning: 'Avertissement',
    company: {
      created: 'Entreprise créée avec succès',
      deleted: 'Entreprise supprimée avec succès',
      deleteError: "Erreur lors de la suppression de l'entreprise",
      updated: 'Entreprise mise à jour avec succès',
      updateError: "Erreur lors de la mise à jour de l'entreprise",
    },
    order: {
      created: 'Commande créée avec succès',
      createError:
        "Erreur lors de la création de la commande! Veuillez contacter le service d'assistance",
      insufficientCredits:
        'Crédits insuffisants pour cette commande. Rechargez vos crédits et réessayez.',
      creditsMisconfigured:
        "Le prix en crédits de cette commande n'a pas pu être calculé. Contactez OrthoSolid — acheter des crédits supplémentaires n'y changera rien.",
    },
    user: {
      created: 'Utilisateur créé avec succès',
      createError: "Erreur lors de la création de l'utilisateur",
    },
    product: {
      addedToCart: 'Produit ajouté au panier',
      removedFromCart: 'Produit retiré du panier',
      cartError: 'Erreur lors de la mise à jour du panier',
      duplicated: 'Le produit a été dupliqué correctement.',
      duplicatedConfig: 'Le produit a été dupliqué correctement avec une nouvelle configuration.',
      deleted: 'Produit supprimé avec succès',
      deleteError: 'Erreur lors de la suppression du produit',
    },
    model: {
      loadError: 'Erreur lors du chargement du modèle',
    },
    message: {
      creditsLow: {
        subject: 'Solde de crédits bas',
        message:
          'Votre organisation n’a plus que {balance} crédits, ce qui ne suffit pas pour un autre fichier numérique. Rechargez pour continuer à commander.',
      },
      creditsRequested: {
        subject: 'Crédits demandés',
        message:
          '{requesterName} a demandé {credits} crédits supplémentaires pour votre organisation.',
      },
      orderPlaced: {
        subject: 'Commande #{orderId} enregistrée.',
        message: 'Votre commande a bien été enregistrée.',
      },
      orderInProcess: {
        subject: 'Commande #{orderId} en cours de traitement',
        message: 'Tous les articles de votre commande sont en cours de fabrication.',
      },
      orderDelayed: {
        subject: 'Commande #{orderId} retardée',
        message:
          'Un problème est survenu lors du traitement de votre commande. Nous vous contacterons si nécessaire.',
      },
      orderShipped: {
        subject: 'Commande #{orderId} terminée',
        message:
          'Tous les articles de votre commande ont été expédiés et vous seront livrés sous peu.',
      },
      orderInvoiced: {
        subject: 'Commande n° {orderId} facturée',
        message: 'Votre commande n° {orderId} a été facturée.',
      },
      productUpdated: {
        subject: 'Mise à jour du produit : {productName} - {productId}',
        message:
          'Le produit "{productName}" (ID: {productId}) a été mis à jour par notre équipe de support.',
      },
      supportHasReactedToYourHelpRequest: {
        subject: "{productName} {productId} a été mis à jour par le service d'assistance",
        message: "Nous avons donné suite à votre demande d'aide.",
      },
      announcement: {
        title: 'Nouvelle annonce',
        description:
          'En appuyant sur « Envoyer la notification », une notification sera envoyée à TOUS les utilisateurs de la plateforme.',
        confirmText: 'Envoyer la notification',
        success: 'La notification a été envoyée à tous les utilisateurs.',
        error:
          "Une erreur s'est produite lors de l'envoi de la notification à tous les utilisateurs.",
        form: {
          subject: {
            title: 'Objet',
            placeholder: 'Veuillez saisir un objet...',
          },
          message: {
            title: 'Message',
            placeholder: 'Veuillez saisir votre message...',
          },
          link: {
            title: 'Link',
            placeholder:
              "Veuillez saisir l'URL vers laquelle vous souhaitez rediriger l'utilisateur...",
          },
        },
      },
      platformUpdates: {
        subject: 'Mises à jour de la plateforme',
        message: 'Nous avons apporté quelques modifications à la plateforme.',
        title: 'Nouvelle mise à jour de la plateforme',
      },
      newsletter: {
        subject: 'Newsletter',
        message: 'Nous avons apporté quelques modifications à la plateforme.',
      },
    },
    userUpdated: 'Utilisateur mis à jour',
    errorUpdatingUser: "Erreur lors de la mise à jour de l'utilisateur",
    notificationsCleared: 'Notifications effacées',
    notificationSettingsUpdated: 'Paramètres de notification mis à jour',
    patientDataUpdated: 'Données patient mises à jour avec succès',
    patientDataUpdateFailed: 'Échec de la mise à jour des données patient',
    fileDownloadedSuccessfully: 'Fichier 3D téléchargé avec succès',
    supportEditsAccepted: 'Modifications du support acceptées',
    supportEditsFailed: "Échec de l'application des modifications du support",
    changeRequestSubmitted: 'Demande de modification soumise avec succès',
    changeRequestFailed: 'Échec de la soumission de la demande de modification',
    mustBeLoggedIn: 'Vous devez être connecté pour demander des modifications',
    commentMinLength:
      "Veuillez fournir un commentaire d'au moins {minLength} caractères pour votre demande de modification",
    delete: {
      title: 'Supprimer la notification',
      message: 'Êtes-vous sûr de vouloir supprimer cette notification ?',
      confirmText: 'Supprimer',
      success: 'Notification supprimée avec succès',
    },
  },
  navigation: {
    back: 'Retour',
    backToList: 'Retour à la liste',
    backToOverview: "Retour à l'aperçu",
    breadcrumbs: "Fil d'Ariane",
    currentPage: 'Page actuelle',
    menu: {
      dashboard: 'Tableau de bord',
      patients: 'Patients',
      products: 'Produits',
      orders: 'Commandes',
      explore: 'Explorer',
      support: 'Support',
      admin: 'Administration',
      manufacturing: 'Production',
      documentation: 'Documentation',
    },
  },
  editor: {
    save: 'Enregistrer les modifications',
    cancel: 'Annuler',
    discard: 'Annuler les modifications',
    confirmDiscard: 'Êtes-vous sûr de vouloir annuler vos modifications?',
  },
  menu: {
    notifications: 'Notifications',
    messages: 'Messages',
    cart: 'Panier',
    settings: 'Paramètres',
    toggleMenu: 'Basculer le menu',
    closeMenu: 'Fermer le menu',
    account: 'Compte',
    createNew: 'Nouveau',
    noNotifications: 'Aucune notification',
    noProducts: 'Aucun produit dans le panier',
    goToCheckout: 'Passer à la caisse',
    accountSettings: 'Paramètres du compte',
    logout: 'Déconnexion',
    newProduct: 'Nouveau produit',
    newDistributorUser: 'Nouvel utilisateur distributeur',
    newMasterUser: 'Nouvel utilisateur principal',
    order: 'Voir la commande',
    reactionFromSupport: 'Voir les modifications',
    announcement: 'En savoir plus',
    platformUpdates: 'Découvrez les nouveautés',
    continue: 'Continuer',
  },
  details: {
    noLabel: 'Aucune étiquette',
    noValue: 'Aucune valeur',
    viewDetails: 'Voir les détails',
    moreInfo: "Plus d'informations",
  },
  cards: {
    viewItem: 'Voir {name}',
    selectItem: 'Sélectionner {name}',
    imageAlt: 'Image de {name}',
    showInfo: 'Afficher les informations',
    hideInfo: 'Masquer les informations',
    favourite: 'Marquer le produit comme favori',
    companyFavourite: "Marquer le produit comme favori de l'entreprise",
  },
  translation: {
    translate: 'Traduire le texte',
    translateTo: 'Traduire en {language}',
    translating: 'Traduction en cours...',
    translationError: 'Erreur lors de la traduction',
    defaultLanguage: 'Langue par défaut',
  },
  brand: {
    name: 'OrthoSolid',
    logoAlt: 'Logo OrthoSolid',
  },
  fileUpload: {
    attachFile: 'Joindre un fichier',
    dragAndDrop: 'Déposer les fichiers ici',
    browse: 'Parcourir',
    maxSize: 'Taille maximale du fichier : {size}',
    invalidType: 'Type de fichier invalide',
    uploadError: 'Erreur lors du téléchargement',
    loadError: "Impossible de charger l'aperçu du fichier 3D",
    gltfExternalRefs:
      'Les fichiers GLTF avec des références externes ne sont pas pris en charge. Veuillez utiliser le format GLB.',
    uploadSuccess: 'Fichier téléchargé avec succès',
    remove: 'Supprimer le fichier',
    validating: 'Validation des fichiers...',
    filesNotSupported:
      'Fichier(s) non pris en charge : {rejectedNames}. Formats acceptés : {acceptedFormats}',
    filesSelected: '{count} sur {max} fichiers sélectionnés',
    uploadInstructions:
      "Votre fichier sera téléchargé. Après le téléchargement, vous pourrez nettoyer et améliorer le scan 3D à l'aide de notre outil 3D Cleaner à l'étape suivante.",
    charactersMinimum: '{count}/{min} caractères minimum',
    color: {
      label: 'Couleur',
      incoming: 'Pas de couleur (couleur du fichier)',
      presets: {
        white: 'Blanc',
        skin: 'Peau',
        blue: 'Bleu',
        green: 'Vert',
        red: 'Rouge',
        black: 'Noir',
      },
    },
  },
  supportTicket: {
    discussion: 'Discussion',
    typeMessage: 'Entrer un message...',
    send: 'Envoyer',
    attachFile: 'Joindre un fichier',
    noComments: 'Pas de commentaires',
    addComment: 'Ajouter un commentaire',
    uploadFile: 'Télécharger un fichier',
    close: 'Fermer',
    success: "Ticket d'assistance créé.",
    error: "Erreur lors de la création du ticket d'assistance.",
    status: {
      received: 'Reçu',
      under_investigation: 'Sous enquête',
      on_hold: 'En attente',
      resolved: 'Résolu',
    },
    productStatus: {
      dataInput: 'Saisie des données',
      designing: 'Conception',
      readyToOrder: 'Prêt à commander',
      inCart: 'Dans le panier',
      helpRequested: 'Aide demandée',
      updatedBySupport: 'Mis à jour par le support',
      ordered: 'Commandé',
      demo: 'Démo',
      designRequested: 'Conception demandée',
      orderedWithoutReview: 'Commandé sans besoin de révision',
      cancelled: 'Annulé',
    },
    orderStatus: {
      orderPlaced: 'Commande passée',
      processing: 'En cours de traitement',
      shipped: 'Terminée',
      invoiced: 'Facturée',
      delayed: 'Retardée',
      ignore: 'Ignorer',
      demo: 'Démonstration',
      designRequested: 'Conception demandée',
      orderedWithoutReview: 'Commandé sans besoin de révision',
      readyForReview: 'Prête pour révision',
      generating3dFile: 'Génération du fichier 3D',
      threeDFileUnderReview: 'Fichier 3D en cours de révision',
      threeDFileAvailable: 'Fichier 3D disponible',
      downloaded: 'Téléchargé',
    },
    exportStatus: {
      notAvailable: 'N/A',
      generating: 'En cours de génération',
      failed: 'Échec',
      missing: 'Manquant',
      emptyFile: 'Fichier vide',
      valid: 'Valide',
    },
    buttonText: 'Envoyer un message contenant un lien vers le modèle',
  },
  workflow: {
    back: 'Retour',
    next: 'Suivant',
    save: 'Enregistrer',
    exit: 'Quitter',
    continue: 'Continuer',
    cancel: 'Annuler',
    finish: 'Terminer',
    instructions: 'Instructions',
    steps: {
      current: 'Étape actuelle',
      previous: 'Étape précédente',
      next: 'Étape suivante',
    },
    navigation: {
      back: 'Retour',
      forward: 'Suivant',
      exit: 'Quitter le workflow',
    },
  },
  patientData: {
    scanOrientation: {
      label: 'Orientation du scan',
      placeholder: "Sélectionner l'orientation du scan",
      left: 'Gauche',
      right: 'Droit',
    },
    dataType: {
      label: 'Type de données',
      file: 'Fichier',
      measurement: 'Mesure',
      form: 'Formulaire',
    },
    upload: {
      alignScan: 'Aligner le scan',
      defineSide: 'Définir le côté du scan',
      selectFile: "Sélectionner un fichier et l'orientation du scan",
      uploadError: 'Erreur lors du téléchargement du fichier',
      description: "Veuillez sélectionner un fichier et l'orientation du scan",
      action: 'Télécharger le fichier',
    },
    createdOn: 'Créé le',
    notes: 'Notes',
    actions: {
      editScan: 'Éditer le scan',
      editMeasurements: 'Éditer les mesures',
      editForm: 'Éditer le formulaire',
    },
    add: 'Ajouter des données patient',
    notFinished: 'Non terminé',
    fields: {
      name: 'Nom',
    },
    linkedProducts: 'Produits liés',
    newProduct: 'Nouveau produit',
    noLinkedProducts: 'Aucun produit lié trouvé',
    dataInput: 'Saisie de données',
    selectDataInput: 'Sélectionnez une saisie de données',
    createdBy: 'Créé par',
    editTitle: 'Modifier les données patient',
  },
  dataGrid: {
    bulkActions: {
      credits: {
        button: 'Crédits',
        title: 'Configurer les crédits',
        description:
          'Seuls les champs remplis sont modifiés. Laissez un champ vide pour conserver la valeur actuelle de chaque société.',
        keep: 'Ne pas modifier',
        enable: 'Activer',
        disable: 'Désactiver',
        unchanged: 'Inchangé',
        apply: 'Appliquer',
        success: 'Paramètres de crédits mis à jour pour {count} sociétés.',
        notAllowed: 'Vous n’êtes pas autorisé à modifier les paramètres de crédits.',
        noChanges: 'Rien à modifier. Remplissez au moins un champ.',
        noCompanies: 'Sélectionnez au moins une société.',
        error: 'Erreur lors de la mise à jour des paramètres de crédits.',
      },
      scheduleExports: 'Planifier les exportes',
      changeStatus: 'Changer le statut',
      downloadProduction: 'Télécharger les fichiers de production',
      downloadCsv: 'Télécharger CSV',
      downloadExports: 'Télécharger les exportations',
      addToCart: 'Ajouter au panier',
      delete: 'Supprimer',
      notifications: {
        statusSuccess: 'Statut changé avec succès',
        statusError: 'Erreur lors du changement de statut',
        productionSuccess: 'Fichiers de production téléchargés avec succès',
        productionError: 'Erreur lors du téléchargement des fichiers de production',
        exportSuccess: 'Exportations téléchargés avec succès',
        exportError: 'Erreur lors du téléchargement des exportations',
        exportErrorExplanation: 'Aucun produit téléchargeable trouvé.',
        exportErrorNoProducts: 'No downloadable products found.',
        exportErrorIncomplete:
          '{failed} of {total} files could not be downloaded ({products}). Check your connection and try again — nothing was marked as downloaded.',
        cartSuccess: 'Produits ajoutés au panier avec succès',
        cartError: "Erreur lors de l'ajout des produits au panier",
        deleteSuccess: 'Produits supprimés avec succès',
        deleteError: 'Erreur lors de la suppression des produits',
        exportsSuccess: 'Exportes téléchargés avec succès',
        exportsError: 'Erreur lors du téléchargement du exportes',
        exportsGenerating: 'Les exports sont en cours de génération. Veuillez réessayer sous peu.',
        orderInfoSuccess: 'Commande .csv téléchargés avec succès',
        orderInfoError: 'Erreur lors du téléchargement des commande .csv',
      },
    },
    filter: {
      title: 'Filtre',
      apply: 'Appliquer le filtre',
      cancel: 'Annuler',
    },
    showOnlyMyPatients: 'Afficher uniquement mes patients',
    showOnlyMyOrders: 'Afficher uniquement mes commandes',
    showOnlyMyProducts: 'Afficher uniquement mes produits',
    search: 'Rechercher...',
    manageColumns: 'Gérer les colonnes',
  },
  help: {
    requestHelp: "Demander de l'aide",
    newTicket: 'Créer un nouveau ticket',
    openTicket: 'Ouvrir un ticket',
    viewTicket: 'Voir le ticket',
  },
  comments: {
    seeModel: 'Voir le modèle',
    download: 'Télécharger',
    author: 'Par {name}',
    createdAt: 'Créé le {date}',
    fileDetails: {
      name: 'Nom',
      size: 'Taille',
      type: 'Type',
    },
    selectedFile: 'Fichier sélectionné',
    removeFile: 'Supprimer le fichier',
  },
  footer: {
    exploreMore: 'Explorer plus de produits',
    back: 'Retour',
    next: 'Suivant',
    exit: 'Enregistrer et quitter',
    contact: 'Contact',
    location: 'Emplacement',
    copyright: '© {year} Orthobroker bv',
    followUs: 'Suivez-nous',
    newsletter: 'Newsletter',
    getUpdates: 'Recevez des mises à jour sur nos derniers produits et offres.',
    on: 'Activé',
    off: 'Désactivé',
    suscribed: 'Vous vous êtes inscrit avec succès à notre newsletter',
    unsubscribed: 'Vous vous êtes désinscrit avec succès de notre newsletter',
    stayUpToDate: 'Restez informé',
    form: {
      email: "L'adresse e-mail",
    },
  },
  visibility: {
    show: 'Afficher les données sensibles',
    hide: 'Masquer les données sensibles',
  },
  dashboard: {
    startCreation: 'Commencer le processus de création',
    addNewPatient: 'Ajouter un nouveau patient',
    addPatientData: 'Ajouter un scan du patient',
    continueDesigning: 'Continuer la conception',
    recentOrders: 'Commandes récentes',
    viewAll: 'Voir tout',
    columns: {
      productName: 'Nom du produit',
      patientName: 'Nom du patient',
      status: 'Statut',
      orderDate: 'Date de commande',
      orderId: 'Numéro de commande',
    },
  },
  redirect: {
    title: 'Redirection nécessaire',
    description: 'Vous devez compléter certaines étapes avant de pouvoir accéder à cette page.',
    patient: 'Sélection du patient',
    dataset: 'Sélection des données',
    product: 'Sélection du produit',
    form: 'Sélection du formulaire',
    goTo: 'Aller à {destination}',
  },
  general: {
    back: 'Retour',
    exit: 'Enregistrer & quitter',
    yes: 'Oui',
    no: 'Non',
    on: 'Allumé',
    off: 'Éteint',
  },
  titles: {
    credits: 'Mes crédits',
    patient: 'Assigner un patient',
    assignPatient: 'Assigner un patient',
    createPatient: 'Créer un nouveau patient',
    product: 'Sélectionner un produit',
    dataset: 'Sélectionner les données',
    selectForm: 'Sélectionner un formulaire',
    editForm: 'Éditer le formulaire',
    newForm: 'Nouveau formulaire',
    selectElimb: 'Sélectionner un E-limb',
    elimb: 'Mesurer un E-limb',
    selectScan: 'Sélectionner un scan',
    alignScan: 'Aligner & nettoyer',
    admin: 'Administration',
    catalog: 'Catalogue',
    checkout: 'Caisse',
    academy: 'Académie',
    explore: 'Explorer',
    orders: 'Commandes',
    tickets: 'Tickets',
    manufacturing: 'Production',
    dashboard: 'Tableau de bord',
    patientData: 'Données du patient',
    products: 'Produits',
    productWorkflowCategory: 'Sélectionner une catégorie',
  },
  product: {
    code: 'Code produit',
    overview: {
      title: 'Aperçu du produit',
    },
    next: 'Sélectionner un dataset',
    sections: {
      generalInfo: 'Informations générales du produit',
      specifications: 'Spécifications du produit',
      details: 'Détails du produit',
    },
    fields: {
      status: 'Statut',
      patient: 'Patient',
      type: 'Type de produit',
      id: 'ID du produit',
      createdOn: 'Créé le',
      createdBy: 'Créé par',
      lastAdjustedOn: 'Dernière modification le',
      lastAdjustedBy: 'Modifié par',
      orderReference: 'Référence de commande',
      linkedScan: 'Scan lié',
      copyFrom: 'Copie de',
      edgePiping: {
        0: 'Désactivé',
        1: 'Partout',
        2: 'Main seulement',
        3: 'Pouce uniquement',
      },
      thumbWebFoldingEdge: {
        0: 'Désactivé',
        1: 'Faiblé',
        2: 'Moyen',
        3: 'Haut',
      },
      buckleType: {
        0: 'Sans boucle',
        1: 'Boucle FDM',
      },
      dorsal: 'Dos',
      palmar: 'Palmaire',
      transversalPalmArchIntensity: {
        0: 'Aucun',
        1: 'Faiblé',
        2: 'Moyen',
        3: 'Haut',
      },
      productFinishing: {
        0: 'Coque imprimée uniquement',
        3: 'Orthèse avec doublure personnalisée',
        1: 'Orthèse avec doublure personnalisée et jeu de sangles séparé',
        2: 'Orthèse avec doublure personnalisée et sangles attachées',
      },
    },
    properties: {
      title: 'Propriétés du Produit',
      edit: 'Modifier les Propriétés',
      hinge_type: 'Type de Charnière',
      brace_thickness: 'Épaisseur de Renfort',
      material: 'Matériau',
      finishing: 'Finition',
      error: 'Erreur lors de la modification des propriétés',
    },
    actions: {
      delete: {
        title: 'Supprimer le produit',
        message: 'Êtes-vous sûr de vouloir supprimer ce produit?',
        confirmText: 'Supprimer',
        error:
          "Le produit {id} ne peut pas être supprimé car il est associé au ticket d'assistance {supportTicketId}.",
      },
      addToCart: 'Ajouter au panier',
      removeFromCart: 'Retirer du panier',
      order: 'Passer à la caisse',
      showSpecifications: 'Montrer les spécifications',
      showInfo: 'Informations sur le produit',
    },
    title: 'Produit',
    new: 'Nouveau produit',
    empty: 'Aucun produit trouvé',
    description: 'Description du produit',
    add: 'Ajouter un produit',
    workflow: {
      instructions: {
        start: `##### **Que souhaitez-vous faire?**
Sélectionnez la variante la plus adaptée.
##### **Conseils:**
- Cliquez sur l'icône d'information pour une brève description du produit`,
        overview: `##### **Aperçu**
Voici l'orthèse que vous allez créer.
##### **Conseils:**
- Vous pouvez ajouter ce modèle à vos favoris en cliquant sur le bouton « Favoris ».`,
        flowStepTitle: '##### **{number}. {question}**',
        overviewTitle: '##### **Aperçu**',
        flowStep: `##### **{number}. {question}**
Choisissez la réponse qui convient le mieux à votre patient.
##### **Conseils:**
- Vous pouvez modifier une réponse précédente en cliquant sur son étape ci-dessus.`,
        noOutcome:
          'Aucun produit ne correspond à ces réponses. Revenez en arrière et modifiez une réponse, ou demandez à un administrateur de compléter le flux de décision.',
        noFlow:
          "Cette famille de produits n'a pas encore de flux de décision actif. Demandez à un administrateur de l'activer.",
        noOptions:
          "Aucune réponse n'est disponible pour cette étape avec les réponses données jusqu'ici.",
        outcomeFailed:
          "Le produit correspondant à ces réponses n'a pas pu être chargé. Vérifiez votre connexion et rechargez la page.",
        outcomeNoWorkflow:
          "Ce produit n'a pas encore de flux de produit et ne peut donc pas être créé. Demandez à un administrateur de le définir.",
        error: "Une erreur s'est produite lors du calcul du résultat.",
      },
      thumbDiameter: {
        confirmText: 'Continuer',
        error: 'Veuillez saisir un diamètre de pouce valide.',
      },
      hingedOption: {
        error: 'Veuillez saisir une option valide pour votre charnière.',
      },
      extraPadding: {
        error: 'Veuillez indiquer si vous souhaitez ou non un rembourrage supplémentaire.',
        chip: {
          yes: 'Rembourrage supplémentaire',
          no: 'Pas de rembourrage supplémentaire',
        },
      },
      paddingThickness: {
        error: "Veuillez saisir une valeur valide pour l'épaisseur du rembourrage.",
      },
      favourite: {
        title: 'Favori',
        success: 'Le produit a été ajouté aux favoris.',
        error: "Erreur lors de l'ajout du produit Carpi Production à vos favoris.",
      },
      unFavourite: {
        title: 'Supprimer des favoris',
        message:
          'Êtes-vous sûr de vouloir supprimer cette variante {product} de votre liste de favoris ?',
        confirmText: 'Supprimer',
        success: 'Configuration du produit désactivée avec succès',
        error: "Erreur lors de la suppression d'un produit de la liste des favoris",
      },
      companyFavourite: {
        title: 'Entreprise favorite',
        success: "Marquer le produit comme favori pour l'entreprise.",
        error: "Erreur lors du marquage du produit comme favori pour l'entreprise.",
      },
      companyUnfavourite: {
        title: "Démarquer le produit comme favori pour l'entreprise.",
        message:
          "Êtes-vous sûr de vouloir supprimer cette variante {product} de votre liste de favoris pour l'entreprise ?",
        confirmText: 'Supprimer',
        success: "Le produit n'est plus marqué comme favori pour l'entreprise.",
        error: "Erreur lors de la suppression du produit des favoris de l'entreprise.",
      },
      outcome: {
        title: 'Aperçu',
      },
      duplicate: {
        baskoMultimotion: 'Basko Multimotion',
        caroliDyna: 'Caroli Dyna',
        caroliMono: 'Caroli Mono',
        albrecht: 'Albrecht',
        ultraFlex: 'UltraFlex',
      },
    },
  },
  productWorkflowCategory: {
    instructions: `##### **De quel produit votre patient a-t-il besoin ?**
Sélectionnez une famille de produits.
##### **Conseils:**
- Cliquez sur l'icône d'information pour obtenir une brève description des produits. 
- Après avoir choisi la famille de produits, vous pouvez choisir la variante que vous souhaitez créer.`,
    next: 'Sélectionner un produit',
  },
  patient: {
    info: 'Informations du patient',
    instructions: `##### **Pour qui créez-vous un produit?**
Créez un nouveau patient ou attribuez-en un de votre liste de patients.`,
    new: 'Nouveau patient',
    pick: 'Sélectionner dans la liste des patients',
    exit: 'Fermer',
    next: 'Sélectionner une catégorie de produits',
    create: 'Ajouter un nouveau patient',
    addPatient: 'Ajouter un patient',
    close: 'Fermer',
    name: 'Nom du patient',
  },
  dataset: {
    elimb: {
      instructions: `##### **Quelles sont les mesures du bras du patient?**
Créez un nouveau E-limb en mesurant votre patient ou sélectionnez-en un dans le profil de votre patient.
##### **Conseils:**
- Assurez-vous que si vous choisissez un E-limb existant, il est toujours à jour
- Lors de la création d'un nouveau E-limb, assurez-vous d'avoir les outils suivants à proximité: Etrier, règle`,
      create: 'Créer un nouveau E-limb',
      select: 'Sélectionner un E-limb du profil du patient',
      empty: 'Aucun E-limb trouvé',
      next: 'Créer un E-limb',
      save: 'Définir les angles des articulations',
    },
    scan: {
      instructions: `##### **Quelles sont les mesures du bras du patient?**
Téléchargez un nouveau scan 3D ou sélectionnez-en un dans le profil de votre patient.
##### **Conseils:**
- Assurez-vous que si vous choisissez un scan 3D existant, il est toujours à jour
- Lorsque vous téléchargez un nouveau scan 3D, vous devrez l'aligner et le nettoyer.
- Pour créer le scan parfait à utiliser dans ce logiciel, voir le manuel de scan`,
      upload: 'Télécharger un nouveau scan 3D',
      select: 'Sélectionner un scan 3D du profil du patient',
      empty: 'Aucun scan 3D trouvé',
      next: 'Nettoyer le scan',
      save: 'Enregistrer la scan nettoyée',
      custom: {
        next: 'Description du produit',
      },
    },
    form: {
      assign: 'Assigner un formulaire',
      empty: 'Aucun formulaire disponible',
      instructions:
        '##### **Veuillez sélectionner un formulaire pour continuer ou en créer un nouveau**',
      select: 'Sélectionner un formulaire',
      new: 'Créer un nouveau formulaire',
      save: 'Enregistrer le formulaire',
      next: 'Étape suivante',
      request: 'Demander un formulaire',
      altNext: 'Commander un formulaire',
      altButton: 'Mettre à jour le formulaire',
      name: {
        title: 'Donnez un nom à votre formulaire.',
        placeholder: 'Entrez le nom',
      },
    },
    configure: 'Créateur de produit',
  },
  list: {
    title: 'Produits',
    empty: 'Aucun produit trouvé',
    fields: {
      productId: 'ID du Produit',
      productType: 'Type de Produit',
      createdOn: 'Créé le',
      status: 'Statut',
    },
    actions: {
      new: 'Nouveau',
    },
  },
  model: {
    locked: 'Le modèle est actuellement verrouillé car il a été commandé ou ajouté au panier.',
  },
  mesh: {
    notFound: {
      title: 'Maillage non trouvé',
      message: "Le maillage n'a pas été trouvé dans la scène",
    },
    loaded: {
      title: 'Maillage chargé',
      message: 'Maillage chargé avec succès',
    },
    align: {
      title: 'Veuillez aligner la numérisation',
      message:
        "Appuyez sur 'Align Scan' avant d'enregistrer la numérisation. (Sauvegarder à nouveau pour continuer sans aligner)",
    },
    clean: {
      title: 'Veuillez nettoyer la numérisation',
      message:
        "Appuyez sur 'Clean Scan' avant d'enregistrer la numérisation. (Sauvegarder à nouveau pour continuer sans nettoyer)",
    },
  },
  settings: {
    title: 'Paramètres',
    sections: {
      company: "Paramètres de l'entreprise",
      user: "Paramètres de l'utilisateur",
      general: 'Paramètres généraux',
    },
    fields: {
      useOwnPatientId: {
        label: 'Utiliser son propre ID patient',
        description: 'Activez cette option pour définir vos propres IDs patient.',
      },
      sharePatients: {
        label: 'Partager les patients',
        description: "Activez cette option pour partager les patients avec d'autres utilisateurs.",
      },
      useShippingInformation: {
        label: "Utiliser les informations d'expédition",
        description: "Activez cette option pour utiliser les informations d'expédition.",
      },
      anonymizedStartUp: {
        label: 'Démarrage anonyme',
        description: 'Activez cette option pour un démarrage anonyme.',
      },
      assistedMode: {
        label: 'Mode assisté',
        description: 'Activez cette option pour le mode assisté.',
      },
      preferredLanguage: {
        label: 'Langue préférée',
        description: 'Sélectionnez votre langue préférée.',
      },
    },
    myAccount: 'Mon compte',
    announcement: {
      button: 'Envoyer une nouvelle annonce',
    },
    platformUpdate: {
      button: 'Envoyer une mise à jour de la plateforme',
    },
    notificationSettings: 'Paramètres de notification',
    notifications: {
      inPlatform: 'Dans la plateforme',
      byEmail: 'Par e-mail',
    },
  },
  scan: {
    title: 'Scan 3D',
    fields: {
      id: 'ID du Scan',
      name: 'Nom du Scan',
      orientation: 'Orientation du Scan',
      lastAdjustedOn: 'Dernière modification le',
      lastAdjustedBy: 'Modifié par',
    },
  },
  elimb: {
    title: 'Elimb Information',
    fields: {
      id: "ID de l'Elimb",
      name: "Nom de l'Elimb",
      orientation: "Orientation de l'Elimb",
      lastAdjustedOn: 'Dernière modification le',
      lastAdjustedBy: 'Modifié par',
    },
  },
  descriptions: {
    credits: 'Achetez des crédits et voyez ce que votre organisation peut encore imprimer.',
    admin: 'Administration',
    catalog: 'Catalogue',
    checkout: 'Caisse',
    academy: 'Académie',
    explore: 'Explorer',
    orders: 'Commandes',
    products: 'Produits',
    tickets: 'Tickets',
  },
  distributor: {
    create: 'Créer un distributeur',
    add: 'Ajouter un utilisateur',
  },
  cart: {
    empty: 'Panier vide',
    delete: {
      title: 'Supprimer le panier',
      message: 'Êtes-vous sûr de vouloir supprimer ce panier ?',
      confirmText: 'Supprimer',
      success: 'Panier supprimé avec succès',
    },
  },
  checkout: {
    title: 'Caisse',
    contactInformation: {
      title: 'Informations de contact',
      description: 'Veuillez entrer vos informations de contact',
    },
    products: {
      title: 'Produits',
      description: 'Vérifiez vos produits avant de passer à la caisse',
    },
  },
  academy: {
    title: 'Académie',
  },
  manufacturing: {
    title: 'Fabrication',
    orders: {
      title: 'Fabrication - Commandes',
      tab: 'Commandes régulières',
    },
    designRequested: {
      title: 'Fabrication - Conception demandée',
    },
    ignoredItems: {
      title: 'Fabrication - Articles ignorés',
      tab: 'Articles ignorés',
    },
    creditOrders: {
      title: 'Fabrication - Demandes de crédits',
      tab: 'Demandes de crédits',
    },
    noItemsFound: 'Aucun article de fabrication trouvé',
    stlFiles: 'Fichiers STL',
    rows: {
      selectRow: 'Sélectionner la ligne',
      unselectRow: 'Désélectionner la ligne',
      selectAllRows: 'Sélectionner toutes les lignes',
      unselectAllRows: 'Désélectionner toutes les lignes',
    },
  },
  tickets: {
    fields: {
      product: 'Produit',
      status: 'Statut',
      createdBy: 'Créé par',
      id: 'ID',
      involving: 'Impliquant',
      description: 'Description',
      company: 'Entreprise',
    },
  },
  products: {
    fields: {
      status: 'Statut',
      name: 'Nom',
      patientName: 'Nom du patient',
      id: 'ID',
      notes: 'Notes',
      producedBy: 'Produit par',
    },
  },
  documentation: {
    title: 'Documentation',
    notAvailable: 'Aucune documentation disponible pour le moment.',
    loading: 'Chargement du contenu...',
    selectDocument: 'Sélectionnez un document dans la table des matières.',
  },
  explore: {
    title: 'Explorer',
  },
  formFields: {
    togglePasswordVisibility: 'afficher/masquer le mot de passe',
  },
  features: {
    currentlyDisabled: 'Cette fonctionnalité est actuellement désactivée',
  },
  components: {
    selectPatient: 'Sélectionner un patient',
    patientLabel: 'Patient',
    meshInspectorFrame: 'Cadre MeshInspector',
    doNotShowAgain: 'Ne plus afficher cette fenêtre',
    submitText: 'Commencez à concevoir',
    supportPreview: {
      title: 'Aperçu du support',
      description:
        "Vous visualisez un aperçu de l'assistance. Acceptez les changements pour continuer",
      accept: 'Acceptez',
    },
    modelPreviews: {
      viewSelection: 'sélection de vue du modèle',
      productView: 'vue du produit',
      patientDataView: 'vue des données du patient',
      finalProduct: 'Produit Final',
      threeDScan: 'Scan 3D',
    },
    meshInspector: {
      saveWarnings: {
        title: 'Enregistrer le scan',
        lead: "Avant d'enregistrer, veuillez noter :",
        notCleanedBullet: "Le maillage n'a pas été nettoyé. Utilisez 'Clean Scan' pour le réparer.",
        notAlignedBullet: "Le scan n'est pas aligné. Utilisez 'Align Scan' pour l'orienter.",
        proceed: 'Enregistrer quand même',
      },
    },
    customProducts: {
      noFormDataAvailable: 'Aucune donnée de formulaire disponible pour ce produit.',
      changeRequestHistory: 'Historique des Demandes de Modification',
      anonymous: 'Anonyme',
      uploadModel: 'Télécharger le modèle',
      uploadModelTitle: 'Télécharger le Modèle',
      productFormData: 'Données du Formulaire de Produit',
      requestChangesButton: {
        title: 'Demander des modifications',
        description:
          "Cette demande modifiera le statut du produit et en informera l'équipe OrthoSolid. Notre équipe examinera vos commentaires et vous fournira une nouvelle version du produit basée sur vos spécifications.",
      },
      buttons: {
        orderTitle: 'Accepter et commander',
      },
      images: {
        title: 'Images jointes',
        description: 'Télécharger de nouvelles images',
      },
      requestProduct: {
        dialog: {
          title: 'Demander un produit personnalisé',
          message: `En commandant ce produit, nous créerons un design personnalisé et vous recevrez ensuite une facture.\n\n**Important :**\n\nVeuillez noter que la création du design peut prendre jusqu'à 3 jours ouvrables. Vous serez tenu informé via les notifications de la plateforme et par e-mail.`,
          confirmText: 'Commander le produit',
        },
      },
      orderProduct: {
        dialog: {
          title: 'Commander le produit',
          message: `En commandant ce produit, nous créerons et imprimerons un design personnalisé sans votre vérification. Le produit sera expédié et facturé.\n\n**Important :**\n\nVeuillez noter que la création du produit peut prendre jusqu'à 12 jours ouvrables. Vous serez tenu informé via les notifications de la plateforme et par e-mail.`,
          confirmText: 'Commander le produit',
        },
      },
      updateForm: {
        dialog: {
          title: 'Formulaire de mise à jour',
          message:
            "La mise à jour du formulaire s'appliquera également aux autres produits qui utilisent ce formulaire.",
        },
      },
    },
  },
  youtubeEmbed: {
    player: 'Lecteur YouTube',
    allowedFeatures:
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
  },
  configurator: {
    calculating: 'Calcul en cours...',
    error: {
      title: 'Erreur',
      description: 'Produit introuvable.',
      brace: {
        title: 'Une parenthèse doit être calculée avant de pouvoir être masquée.',
      },
    },
    menu: {
      customTextLimit: "Entrez jusqu'à 20 caractères. ({length} utilisé)",
      notes: {
        title: 'Informations pour la production',
        productLabel: "Indiquer le nom du patient sur l'étiquette du produit",
        placeholder: 'Cliquez pour ajouter des notes...',
      },
    },
  },
  volarShell: {
    error: {
      noAcces: "Vous n'avez pas accès à ce produit.",
      noShell: "Aucun fichier shell n'est disponible pour ce produit.",
      couldNotGenerate: 'Impossible de générer un lien de téléchargement pour le fichier shell.',
      failed: 'Échec de la récupération du fichier shell.',
    },
  },
  stlDownload: {
    buttonSingular: {
      title: 'Télécharger le fichier 3D',
    },
    buttonMultiple: {
      title: 'Télécharger les fichiers 3D',
    },
    buttonMultipleOrSingular: {
      title: 'Télécharger le(s) fichier(s) 3D',
    },
    buttonGenerating: {
      title: 'Génération du fichier 3D',
    },
    buttonGeneratingMultiple: {
      title: 'Génération du/des fichier(s) 3D',
    },
    notification: {
      success: 'Les fichiers 3D ont été téléchargés avec succès !',
    },
  },
  demo: {
    form: {
      title: 'Orthosolid Demo',
      email: "L'adresse e-mail",
      name: 'Nom complet',
      company: 'Entreprise',
      carpi: 'Orthosolid Carpi Demo',
      mino: 'Orthosolid Mino Demo',
      volar: 'Orthosolid Volar Demo',
    },
    reset: 'Réinitialiser',
    contactForm: {
      title: 'Formulaire de contact',
      field: 'Texte',
      placeholder: "Entrez votre message à l'attention d'Orthobroker.",
    },
  },
  marketingWebsite: {
    contact: {
      form: {
        name: 'Nom',
        company: 'Entreprise',
        email: 'E-mail',
        message: 'Message',
        submit: 'Envoyer',
        value: 'Valeur',
        success:
          "Merci d'avoir contacté OrthoSolid. Nous vous répondrons dans les plus brefs délais.",
        error:
          "Une erreur s'est produite lors du traitement de votre message. Nous vous suggérons de nous envoyer directement un e-mail à l'adresse info@orthobroker.com.",
        recaptchaError: 'Veuillez remplir le reCAPTCHA.',
      },
    },
  },
  notificationTypes: {
    creditsLow: 'Solde de crédits bas',
    creditsRequested: 'Demandes de crédits',
    orderPlaced: 'Commande passée',
    orderInProcess: 'Commande en cours',
    orderDelayed: 'Commande retardée',
    orderShipped: 'Commande terminée',
    orderInvoiced: 'Commande facturée',
    reactionsFromSupport: 'Réactions du support',
    platformUpdates: 'Mises à jour de la plateforme',
    newsletter: 'Newsletter',
  },
  insights: {
    useCases: "Cas d'utilisation",
    guides: 'Guides',
    webinars: 'Webinaires',
    comparisons: 'Comparaisons',
  },
  website: {
    menu: 'Menu',
  },
  addToCart: {
    errors: {
      noInput:
        "Il semble qu'aucun produit n'ait été sélectionné. Veuillez réessayer en choisissant un produit.",
      notReadyToOrder:
        "Ce produit n'est pas encore disponible à la commande. Veuillez le modifier avant de passer commande.",
      addingToCart:
        "Une erreur s'est produite lors de l'ajout du produit au panier. Veuillez contacter le service client.",
    },
  },
  credits: {
    checkout: {
      title: 'Crédits',
      cost: 'Cette commande coûte',
      balance: 'Votre solde',
      after: 'Solde après cette commande',
      amount: '{credits} crédits',
      amountOne: '1 crédit',
      alreadyPaid: 'Déjà payé',
      unknownCost: 'Prix inconnu',
      shortfall: 'Il vous manque {credits} crédits pour passer cette commande.',
      shortfallOne: 'Il vous manque 1 crédit pour passer cette commande.',
      buy: 'Acheter des crédits',
      requestMore: 'Demander plus de crédits',
      unpriced:
        'Un ou plusieurs produits numériques de cette commande n’ont pas encore de prix en crédits. Contactez Orthobroker avant de commander.',
      covered: 'Votre solde couvre cette commande.',
    },
    cart: {
      blocked:
        'Vous n’avez pas assez de crédits pour ce produit. Il vous manque {credits} crédits.',
      blockedOne: 'Vous n’avez pas assez de crédits pour ce produit. Il vous manque 1 crédit.',
      blockedUnpriced:
        'Ce produit n’a pas encore de prix en crédits. Contactez Orthobroker avant de l’ajouter.',
    },
    request: {
      sent: 'Votre demande a été envoyée aux administrateurs de votre organisation.',
      sentShort: 'Demande envoyée',
      noAdmins:
        'Votre organisation n’a aucun administrateur à qui envoyer cette demande. Contactez Orthobroker.',
      failed: 'Nous n’avons pas pu envoyer votre demande. Veuillez réessayer.',
    },
    available: 'Crédits disponibles',
    topUp: 'Recharger',
    requestMore: 'Demander plus de crédits',
    requestMoreHint: 'Demandez à un administrateur de votre société de recharger vos crédits.',
    expiry: '{amount} crédits expirent le {date}',
    expiryOne: '1 crédit expire le {date}',
    printsLeft: '{prints} impressions restantes',
    printsLeftOne: '1 impression restante',
    noPacks: "Aucun pack de crédits n'est disponible pour le moment.",
    loadError: 'Impossible de charger vos crédits. Veuillez réessayer.',
    currency: {
      label: 'Changer de devise :',
      note: "Les prix affichés dans une devise autre que l'EUR sont indicatifs.",
    },
    orderStatus: {
      requested: 'Demandé',
      confirmed: 'Confirmé',
      cancelled: 'Annulé',
    },
    table: {
      distributor: 'Distributeur',
      credits: 'Crédits',
      price: 'Prix',
      pack: 'Pack',
      requestedBy: 'Demandé par',
      requestedAt: 'Demandé le',
      confirmedAt: 'Confirmé le',
    },
    pack: {
      save: 'Économisez {amount}',
      prints: '{prints} impressions',
      printsOne: '1 impression',
      add: 'Ajouter',
      addHint: 'Demandez ce pack. Orthobroker vous facturera et ajoutera les crédits.',
      expiry: "Les crédits achetés aujourd'hui expireront le {date}",
      requested: 'Demandé',
      requestSuccessTitle: 'Demande envoyée',
      requestSuccess:
        'Nous avons reçu votre demande de {credits} crédits. Orthobroker vous facturera et les crédits seront ajoutés dès confirmation du paiement.',
      requestNotAllowed:
        "L'administrateur de votre entreprise doit demander des crédits pour votre organisation.",
      requestUnavailable: "Ce pack n'est pas disponible pour votre entreprise pour le moment.",
      rateUnavailable: "Affiché en euros : le taux {currency} n'est pas disponible pour le moment.",
      requestFailed: "Nous n'avons pas pu envoyer votre demande. Veuillez réessayer.",
    },
    categories: {
      carpi: 'Carpi',
      mino: 'Mino',
      volar: 'Volar',
    },
    faq: {
      title: 'À propos des crédits',
      q1: 'Que sont les crédits ?',
      a1: "Les crédits permettent d'acheter des fichiers numériques que vous pouvez imprimer en 3D dans votre propre atelier.",
      q2: 'Les produits fabriqués par Orthobroker sont-ils inclus dans le système de crédits ?',
      a2: 'Non. Les produits fabriqués et livrés par Orthobroker sont facturés séparément.',
      q3: 'Les crédits peuvent-ils être partagés au sein de mon organisation ?',
      a3: "Oui. Les crédits sont partagés dans l'ensemble de votre organisation et peuvent être utilisés par tous les professionnels.",
      q4: 'Les crédits expirent-ils ?',
      a4: "Oui. Tous les crédits expirent {months} mois après la date d'achat.",
      q5: 'Combien de crédits coûte un fichier numérique ?',
      a5: "Le nombre de crédits nécessaires dépend du produit concerné et s'affiche avant l'achat.",
    },
  },
  decisionFlows: {
    title: 'Parcours de décision produit',
    description:
      'Créez sans code le questionnaire qui choisit un produit et ses paramètres de départ.',
    loading: 'Chargement des parcours',
    saving: 'Enregistrement…',
    flow: 'Parcours',
    untitled: 'Sans titre',
    reorder:
      'Réordonner {name} : faites-le glisser, utilisez les flèches ou ouvrez-le pour le monter ou le descendre',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    tabs: {
      questions: 'Questions',
      outcomes: 'Résultats finaux',
      credits: 'Système de crédits',
      simulator: 'Essayer',
    },
    credits: {
      intro:
        'Décidez quand un produit créé avec ce parcours consomme des crédits du compte du client. La règle est vérifiée lors de la commande du produit.',
      match: 'Consommer des crédits quand',
      matches: {
        all: 'Toutes les conditions sont remplies (ET)',
        any: 'Une condition est remplie (OU)',
      },
      legend: 'Conditions',
      noQuestions:
        "Aucune question n'enregistre sa réponse dans la configuration du produit, donc aucune ne peut décider des crédits.",
      unpriced:
        'Cette catégorie n’a pas de prix en crédits : le paiement refuse tout produit que la règle sélectionne.',
      fallback:
        "Aucune condition : la règle intégrée s'applique, et seuls les produits que le client produit lui-même consomment des crédits.",
    },
    toolbar: {
      importJson: 'Importer le JSON',
      exportJson: 'Exporter le JSON',
      imported: '{title} importé',
      exported: '{file} exporté',
      fileTooLarge: 'Le fichier dépasse {size}.',
      hideList: 'Masquer la liste',
      showList: 'Afficher la liste',
    },
    flows: {
      none: "Il n'y a pas encore de parcours. Créez le premier pour commencer.",
      create: 'Nouveau parcours',
      createTitle: 'Nouveau parcours',
      settingsTitle: 'Réglages du parcours',
      name: 'Nom du parcours',
      category: 'Catégorie de produit',
      categoryHint: 'Détermine parmi quels produits ce parcours peut choisir.',
      noCategory: 'Sans catégorie',
      saveSettings: 'Enregistrer les réglages',
      duplicateTitle: 'Dupliquer le parcours',
      duplicate: 'Créer une copie',
      copyName: '{title} (copie)',
      live: 'Utiliser pour la création de produits',
      liveHint:
        "La création de produits de cette catégorie suit ce parcours. L'activer désactive tout autre parcours de la catégorie.",
      liveNeedsCategory:
        "Choisissez d'abord une catégorie de produit : le parcours guide la création de produits de cette catégorie.",
      liveWithIssues:
        "Ce parcours a {count} problèmes. La création de produits s'arrête là où ils laissent un vide.",
      liveTag: 'en création de produits',
      cancel: 'Annuler',
      delete: 'Supprimer le parcours',
      more: 'Autres actions du parcours',
    },
    deleteFlow: {
      title: 'Supprimer ce parcours ?',
      body: '{title} sera supprimé avec ses questions et ses résultats finaux. Action irréversible.',
      confirm: 'Supprimer le parcours',
    },
    confirmDelete: {
      confirm: 'Supprimer',
      cancel: 'Annuler',
      title: 'Supprimer {name} ?',
      conditionTitle: 'Supprimer la condition sur {question} ?',
      combinationTitle: 'Supprimer la combinaison {number} ?',
      question:
        'Ses réponses partent avec elle, et les conditions et combinaisons qui la lisent l’oublient. Cette action est irréversible.',
      answer:
        'Les conditions et combinaisons qui choisissent cette réponse l’oublient. Cette action est irréversible.',
      condition: 'Sans elle, ceci ne dépend plus de cette question. Cette action est irréversible.',
      parameter: 'Cette valeur n’est plus définie. Cette action est irréversible.',
      dialog: 'La boîte de dialogue et ses choix sont supprimés. Cette action est irréversible.',
      choice: 'Le choix et ses paramètres sont supprimés. Cette action est irréversible.',
      combination:
        'Ces réponses ne choisissent plus son produit. La configuration produit elle-même est conservée. Cette action est irréversible.',
    },
    stepTypes: {
      decisionQuestion: 'Question',
    },
    fields: {
      target: "S'applique à",
      targets: {
        shapediver: 'Modèle 3D',
        product: 'Produit',
      },
      numberRequired: 'Saisissez un nombre',
      translate: 'Traduire depuis l’anglais',
      translations: 'Traductions ({filled}/{total})',
      translateFailed: 'Rien n’a été traduit. Réessayez dans un instant.',
      linked: "Partagé avec l'assistant produit : une modification ici s'y affiche aussi",
      linkedNameKept:
        "Un nom est requis : celui enregistré reste jusqu'à ce que vous en saisissiez un nouveau",
      translated: 'Traduit en {count} langues',
      markdown: {
        bold: 'Gras',
        italic: 'Italique',
        heading: 'Titre',
        bulletList: 'Liste à puces',
        orderedList: 'Liste numérotée',
      },
      pick: 'Choisissez un champ…',
      unknown: '{name} (pas un paramètre du modèle 3D)',
      unknownError:
        '{name} n’est pas un paramètre des modèles 3D des produits {category} que ce parcours peut créer. Choisissez-en un dans la liste.',
      modelHint:
        'Issu des modèles 3D des produits {category} que ce parcours peut créer. Un nom que tous les produits n’ont pas indique lesquels l’ont.',
      modelEmpty:
        'Les produits de {category} n’ont pas encore de session ShapeDiver synchronisée : aucun paramètre à choisir.',
      misspelled: 'Écrit autrement dans d’autres modèles',
      spellingWarning:
        'D’autres modèles 3D écrivent ce paramètre {spellings}. Une valeur n’atteint que les modèles qui l’écrivent exactement ainsi : renommez le paramètre dans ShapeDiver pour que tous les modèles concordent.',
      noCategory:
        'Attribuez d’abord une catégorie à ce parcours : les modèles 3D de ses produits sont ce que vous pouvez choisir ici.',
    },
    questions: {
      empty: "Ce parcours n'a pas encore de questions. Ajoutez la première ci-dessous.",
      count: 'Questions : {count}',
      addQuestion: 'Ajouter une question',
      questionTitle: 'Question',
      instructions: 'Texte de la carte verte',
      instructionsHint: "Markdown affiché sous la question dans l'assistant produit",
      answerField: 'Paramètre du configurateur',
      answerFieldHint:
        'Chaque réponse donne sa valeur à ce paramètre du modèle 3D. Laissée vide, la question ne règle rien dans le configurateur.',
      disabled: 'Désactivée',
      disabledDescription:
        'Appliqué dans la boîte de dialogue pour dupliquer un produit vers une autre configuration',
      decidedValue: 'Valeur de {field}',
      setDecidedValue: 'Définir {field}',
      clearDecidedValue: 'Effacer la valeur de {field}',
      answerCount: '{count} réponses',
      options: 'Réponses',
      optionLabel: 'Réponse',
      addOption: 'Ajouter une réponse',
      olderParameters:
        'Définit aussi {values}, d’avant que les réponses perdent leur liste de paramètres.',
      removeOlderParameters: 'Les retirer',
      removeOption: 'Retirer la réponse {name}',
      deleteStep: 'Supprimer {name}',
      parameterName: 'Enregistré dans',
      min: 'Minimum',
      max: 'Maximum',
      step: 'Pas',
      unit: 'Unité',
      defaultValue: 'Valeur par défaut',
    },
    conditions: {
      stepLegend: 'Demander seulement si',
      optionLegend: 'Afficher seulement si',
      question: 'Question',
      answers: 'Réponses',
      add: 'Ajouter une condition',
      remove: 'Retirer la condition sur {question}',
      pickAnswers: 'Choisissez au moins une réponse',
    },
    dialogs: {
      add: 'Ajouter une boîte de dialogue',
      count: 'Boîtes de dialogue',
      dialogTitle: 'Titre de la boîte de dialogue',
      description: 'Description',
      control: 'Contrôle',
      controls: {
        single: 'Un seul choix',
        multi: 'Plusieurs choix',
        number: 'Nombre',
        text: 'Texte',
      },
      optional: 'Facultatif',
      showOnOutcome: 'Afficher sur la carte du résultat final',
      choiceLabel: 'Choix',
      addChoice: 'Ajouter un choix',
      skip: 'Ignorer',
      removeChoice: 'Retirer le choix {name}',
      remove: 'Retirer la boîte de dialogue {name}',
      value: 'Valeur',
    },
    outcomes: {
      addRow: 'Ajouter une combinaison',
      overview: "Texte de l'aperçu",
      overviewHint:
        "Markdown sur la carte verte de la dernière étape de l'assistant, Aperçu. Laissé vide, le texte par défaut s'affiche.",
      addMissing: 'Ajouter les combinaisons manquantes',
      missingTitle: 'Combinaisons manquantes : {count}',
      addMissingRow: 'Ajouter une combinaison',
      addMissingRowFor: 'Ajouter une combinaison pour {answers}',
      missingMore:
        '{count} autres ne sont pas listées. « Ajouter les combinaisons manquantes » les ajoute toutes.',
      anyAnswer: 'Toutes réponses',
      rowCount: 'Combinaisons : {count}',
      hint: 'Choisissez chaque réponse couverte par une combinaison. Les réponses exclues par ses autres cellules sont grisées, et une question qu’elle ne pose jamais reste vide.',
      table: 'Tableau des résultats finaux',
      actions: 'Actions',
      any: "N'importe laquelle",
      choose: 'Choisir…',
      notAsked: 'Non posée',
      name: 'Nom',
      image: 'Image',
      answerCell: '{question}, combinaison {number}',
      openDetails: 'Détails de la combinaison {number}',
      deleteRow: 'Supprimer la combinaison {number}',
      details: 'Combinaison {number}',
      productTemplate: 'Flux de produit',
      productHint:
        'L’enregistrement de la combinaison crée sa propre configuration produit, qui porte le nom, le flux, l’image et les réponses.',
      linkedHint:
        'Les modifications s’appliquent lorsque vous enregistrez la combinaison. Un produit utilisé par un autre flux ou une autre catégorie reçoit sa propre copie.',
      discard: 'Annuler les modifications',
      saveRow: 'Enregistrer la combinaison {number}',
      saved: 'Combinaison {number} enregistrée',
      close: 'Fermer',
      product: 'Produit',
      imageUpload: 'Téléverser une image',
      imageReplace: 'Remplacer l’image',
      imageUploading: 'Téléversement…',
      imagePending: 'Enregistrée avec la combinaison',
      imageNeedsSave:
        'Enregistrez d’abord la combinaison : l’image appartient au produit qu’elle crée.',
      imageFailed: 'L’image n’a pas pu être téléversée. Veuillez réessayer.',
      imageBrowse: 'Parcourir les images de la galerie',
    },
    parameters: {
      title: 'Paramètres',
      name: 'Champ',
      remove: 'Retirer le paramètre {name}',
      valueType: 'Type de valeur',
      reservedName: 'Ce nom est réservé, veuillez en choisir un autre.',
      valueTypes: {
        decisionParameterNumber: 'Nombre',
        decisionParameterBoolean: 'Oui / non',
        decisionParameterString: 'Texte',
      },
      value: 'Valeur',
      add: 'Ajouter un paramètre',
      help: 'Valeurs définies lorsqu’il s’applique, chacune pour un paramètre du modèle 3D ou un champ produit. La destination et le type de la valeur suivent le champ.',
      pickOption: 'Choisir une option…',
      unsynced:
        'Synchronisez la session ShapeDiver de ce paramètre pour choisir parmi ses options.',
      true: 'Vrai',
      false: 'Faux',
    },
    simulator: {
      title: 'Essayer le questionnaire',
      restart: 'Recommencer',
      change: 'Modifier',
      changeAnswer: 'Modifier la réponse à {question}',
      valueHint: 'Entre {min} et {max}',
      outOfRange: 'Saisissez une valeur entre {min} et {max}',
      result: 'Produit sélectionné',
      shapediverParameters: 'Réglages du modèle 3D',
      productParameters: 'Paramètres du produit',
      noParameters: 'Aucun',
      invalid: 'Le questionnaire ne peut pas continuer :',
    },
    issues: {
      none: 'Aucun problème trouvé',
      count: 'Problèmes : {count}',
      emptyQuestion: "Cette question n'a aucune réponse.",
      emptyFlow: "Le parcours n'a aucune étape.",
      unknownCondition: "Une condition lit une question qui n'est pas dans le parcours.",
      forwardCondition: 'Une condition lit une question posée plus tard.',
      resultWithoutProduct: 'Cette combinaison n’a pas de produit.',
      unknownAnswer: 'Une condition ou une combinaison pointe vers une réponse qui n’existe plus.',
      unreachableResult:
        'Une combinaison plus précise l’emporte toujours sur celle-ci, elle n’est donc jamais utilisée.',
      conflictingResults: 'Une autre combinaison est tout aussi précise pour les mêmes réponses.',
      impossibleResult:
        'Ces réponses ne peuvent jamais être données ensemble, cette combinaison n’est donc jamais utilisée.',
      unansweredCell:
        'Choisissez les réponses couvertes par cette combinaison pour chaque question qu’elle pose.',
      impossibleAnswer:
        'Une réponse choisie ici ne peut jamais aller avec les autres réponses de cette combinaison.',
      duplicateResult: 'Une autre combinaison a exactement les mêmes réponses.',
      missingResult: 'Certaines combinaisons de réponses ne mènent à aucun produit.',
      tooManyCombinations:
        'Ce parcours a trop de combinaisons de réponses pour être vérifié entièrement.',
      emptyDialog: 'Cette boîte de dialogue ne demande rien : ni choix, ni paramètre à renseigner.',
      invalidDialogBounds: 'Le minimum dépasse le maximum, ou le pas n’est pas supérieur à zéro.',
      undeclaredAnswerField:
        'Cette question règle un paramètre du configurateur que n’ont pas les modèles 3D que ce parcours peut créer.',
      unknownProductField:
        'Cette réponse définit une valeur de produit qui n’est pas un champ du produit, les nouveaux produits l’ignorent donc. Envoyez-la plutôt au modèle 3D.',
      invalidCreditCondition:
        'Une condition de crédits n’a aucune réponse, ou lit une question dont la réponse n’est pas enregistrée sur le produit : les commandes l’ignorent.',
    },
    parseErrors: {
      invalidJson: "Le fichier n'est pas un JSON valide.",
      notAFlow: "Le fichier n'est pas un parcours de décision produit.",
      invalidStep: "Une étape n'est pas valide ({path}).",
      invalidOption: "Une réponse n'est pas valide ({path}).",
      invalidParameter: "Un paramètre n'est pas valide ({path}).",
      invalidResult: 'Une combinaison n’est pas valide ({path}).',
      invalidCondition: "Une condition n'est pas valide ({path}).",
      invalidDialog: "Une boîte de dialogue n'est pas valide ({path}).",
      invalidAnswerField: "Un champ de question n'est pas valide ({path}).",
      duplicateKey: 'Deux éléments partagent la même clé ({path}).',
      unknownField: 'Le fichier contient un champ que le format du flux ne connaît pas ({path}).',
      tooLarge: 'Le flux contient trop d’éléments pour être ouvert ({path}).',
    },
    storage: {
      'not-allowed':
        "Sanity a refusé cette action. Vérifiez que vous êtes connecté et que votre rôle l'autorise.",
      otherDataset: 'Les flux de décision ne se modifient que dans l’espace de travail {dataset}.',
      openDataset: "Ouvrir l'éditeur {dataset}",
      linkedFailed:
        "Un texte partagé n'a pas pu être enregistré. Rechargez cet onglet pour voir la version enregistrée.",
      'not-found': "Ce parcours n'existe plus.",
      dropped: 'Des parcours illisibles ont été ignorés : {count}.',
      invalid: "Les modifications n'ont pas pu être enregistrées : le parcours n'est pas valide.",
      failed: "Les modifications n'ont pas pu être enregistrées. Veuillez réessayer.",
    },
  },
};

export default fr;
